// src/service/Inscripcion.js
import instance from '../apis/app';

const Inscripcion = {
  /**
   * Obtiene inscripciones del usuario
   */
  MisInscripciones: async (filtros = {}) => {
    try {
      const params = new URLSearchParams();
      if (filtros.estado) params.append('estado', filtros.estado);
      if (filtros.vigente !== undefined) params.append('vigente', filtros.vigente);

      const response = await instance.get(
        `/inscripciones/mis-inscripciones?${params}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * ¿Esta persona ya está inscrita en este horario?
   *
   * Lo usa el paso "Datos" al elegir al participante, para avisar antes de pagar.
   * Devuelve { inscrito, taller, fechaInscripcion }.
   */
  VerificarInscripcion: async (horarioId, rut) => {
    try {
      const params = new URLSearchParams({ horarioId, rut });
      const response = await instance.get(`/inscripciones/verificar?${params}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Obtiene inscripción por ID
   */
  Get: async (inscripcionId) => {
    try {
      const response = await instance.get(`/inscripciones/${inscripcionId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Da de baja a una inscripción (admin/coordinador)
   */
  DarDeBaja: async (inscripcionId) => {
    try {
      const response = await instance.patch(`/inscripciones/${inscripcionId}/dar-de-baja`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Talleres a los que se puede cambiar una inscripción, con sus horarios con cupo
   * y el saldo que resultaría en cada uno (admin)
   * @param {string} inscripcionId
   */
  OpcionesCambioTaller: async (inscripcionId) => {
    try {
      // El interceptor de axios ya devuelve el cuerpo: { success, data }
      return await instance.get(`/inscripciones/${inscripcionId}/opciones-cambio-taller`);
    } catch (error) {
      const msg = error.response?.data?.message || error.message || 'Error al cargar talleres';
      throw { message: msg, status: error.response?.status };
    }
  },

  /**
   * Cambia el horario de una inscripción activa (admin/coordinador). Si el horario
   * es de otro taller, la respuesta trae `cambio` con el saldo.
   * @param {string} inscripcionId
   * @param {string} nuevoHorarioId
   */
  CambiarHorario: async (inscripcionId, nuevoHorarioId) => {
    try {
      const response = await instance.patch(
        `/inscripciones/${inscripcionId}/cambiar-horario`,
        { nuevoHorarioId }
      );
      // Cuerpo completo ({ success, data, cambio, message }): `cambio` trae el saldo
      return response;
    } catch (error) {
      const msg = error.response?.data?.message || error.response?.data?.error || error.message || 'Error al cambiar horario';
      throw { message: msg, status: error.response?.status };
    }
  },
};

export default Inscripcion;
